import { render } from "./MerchantSavePage.vue?vue&type=template&id=499f21e7"
import script from "./MerchantSavePage.vue?vue&type=script&lang=js"
export * from "./MerchantSavePage.vue?vue&type=script&lang=js"
script.render = render

export default script